import { render, staticRenderFns } from "./participant-index.vue?vue&type=template&id=04569b38&scoped=true&"
import script from "./participant-index.vue?vue&type=script&lang=ts&"
export * from "./participant-index.vue?vue&type=script&lang=ts&"
import style0 from "./participant-index.vue?vue&type=style&index=0&id=04569b38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04569b38",
  null
  
)

export default component.exports